import { Avatar, Card, List, Typography } from "antd";
import { ShopOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

const AccountChooser = ({ accounts, onSelect, loading = false }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="app-auth-form-footer">
        <h2>{t("choose_business")}</h2>
        <p>{t("choose_business_description")}</p>
      </div>
      <List
        dataSource={accounts}
        rowKey={(account) => account.company_id}
        renderItem={(account) => (
          <List.Item>
            <Card
              hoverable={!loading}
              onClick={() => {
                if (!loading) onSelect(account);
              }}
              style={{ width: "100%", opacity: loading ? 0.7 : 1 }}
            >
              <Card.Meta
                avatar={
                  <Avatar
                    size={48}
                    src={account.logo}
                    icon={!account.logo ? <ShopOutlined /> : undefined}
                  />
                }
                title={account.business_name || t("business_name")}
                description={
                  account.subdomain ? (
                    <Text type="secondary">{account.subdomain}</Text>
                  ) : null
                }
              />
            </Card>
          </List.Item>
        )}
      />
    </div>
  );
};

export default AccountChooser;
